import Icon from "../common/Icon";
import { useNavigate } from "react-router-dom";
import { cleanHTML, cleanHTML2, flattenHTML } from "../utils/commonHelper";

const ListingComponent = ({ item }) => {
  const navigate = useNavigate();

  return (
    <div
      title="Click to view recipie details"
      className="flex flex-col  justify-start relative sm:flex-row bg-white hover:text-orange  cursor-pointer gap-2 sm:gap-6 lg:gap-6 py-4 px-6 sm:items-center justify-between rounded-[15px] hover:shadow-lg relative"
      onClick={() => navigate(`/recipes/${item._id}`)}
    >
      {/* Recipe Image */}
      {item.image && (
        <img
          src={process.env.REACT_APP_BACKEND_URL + "public/" + item.image}
          alt={item.title}
          onError={(e) => {
            e.currentTarget.src = require("../../assets/images/link.png"); // path to default image
            e.currentTarget.classList.add("object-contain"); // optional styling
          }}
          className=" w-[100px] h-[100px] md:w-[100px] md:h-[100px] object-cover rounded-lg shadow-md bg-gray mb-2 md:mb-0"
        />
      )}

      {/* Middle Section */}
      <div className="flex-1 md:relative md:p-3 rounded-md">
        {/* Hover overlay */}
        <div className="absolute inset-0 hover:bg-green-100 transition-colors rounded-md pointer-events-none"></div>

        {/* Plus Icon */}
        <div
          className="absolute top-2 right-2 md:-top-0 md:-right-2"
          title="View details"
        >
          <Icon icon="plus" size={28} className="hover:text-orange" />
        </div>

        {/* Content */}
        <div className="flex flex-col gap-2 me-4">
          {item.title && (
            <p className="title text-green text-28pt leading-tight">
              {item.title}
            </p>
          )}

          {item.description && (
            <div
              className="parent terms-container text-secondary"
              dangerouslySetInnerHTML={{
                __html: flattenHTML(item.description),
              }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListingComponent;
